// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__162o-","colMin":"styles_colMin__gCTyI"};